import useBackendClient from "@/client";
import { AxiosError } from "axios";

type ImportCSVData = {
  success: boolean;
  count: number;
  errors: string[];
};

const uploadCampaignsCSVCall = (gameId: string, versionId: string) => {
  const { client, useAxios } = useBackendClient();
  const { execute } = useAxios(
    `/app/${gameId}/version/${versionId}/campaigns/import`,
    {
      method: "post",
    },
    client,
    { immediate: false }
  );

  return execute;
};

export default async (gameId: string, versionId: string, file: File | Blob) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const call = await uploadCampaignsCSVCall(
      gameId,
      versionId
    )({
      data: formData,
    });

    return { success: true, count: call.response.value?.data.count, errors: [] };
  } catch (error) {
    const axiosError = error as AxiosError;
    const data = axiosError.response?.data as ImportCSVData;
    const errors = data?.errors || [axiosError.response?.status?.toString() || "Unknow Error"];

    return { success: false, count: data?.count || 0, errors };
  }
};
